import * as React from "react"

const Button = ({ text, as = 'button', className = '', ...props }) => {
  const As = as
  return (
    <As className={'button ' + className} {...props}>{text}</As>
  )
}
export default Button
